import type { ReactElement } from 'react';
import { EDGE_LABEL_BACKGROUND } from './flowchart-constants';
import { FlowchartMarkerKind } from './parse-mermaid-flowchart';
const MARKER_SIZE = 9;
const MARKER_UNITS_USER_SPACE = 'userSpaceOnUse';
const ARROW_MARKER_REF_X = 8;
const ARROW_MARKER_REF_Y = 4;
const CENTER_MARKER_REF = 4.5;
const CIRCLE_MARKER_RADIUS = 3;
const CIRCLE_MARKER_STROKE_WIDTH = 1.2;
const CROSS_MARKER_STROKE_WIDTH = 1.4;
const ARROW_MARKER_PATH = 'M0.5 0.5 L8.5 4 L0.5 7.5 L2.5 4 Z';
const CROSS_MARKER_PATH = 'M1.5 1.5 L7.5 7.5 M7.5 1.5 L1.5 7.5';
interface FlowchartEdgeMarkerProps {
    color: string;
    id: string;
    kind: FlowchartMarkerKind;
    orient: string;
}
export function FlowchartEdgeMarker({ color, id, kind, orient, }: FlowchartEdgeMarkerProps): ReactElement | null {
    if (kind === FlowchartMarkerKind.Arrow) {
        return (
        <marker id={id} markerWidth={MARKER_SIZE} markerHeight={MARKER_SIZE} refX={ARROW_MARKER_REF_X} refY={ARROW_MARKER_REF_Y} orient={orient} markerUnits={MARKER_UNITS_USER_SPACE}>
          <path d={ARROW_MARKER_PATH} fill={color}/>
        </marker>
      );
    }
    if (kind === FlowchartMarkerKind.Circle) {
        return (
        <marker id={id} markerWidth={MARKER_SIZE} markerHeight={MARKER_SIZE} refX={CENTER_MARKER_REF} refY={CENTER_MARKER_REF} orient={orient} markerUnits={MARKER_UNITS_USER_SPACE}>
          <circle cx={CENTER_MARKER_REF} cy={CENTER_MARKER_REF} r={CIRCLE_MARKER_RADIUS} fill={EDGE_LABEL_BACKGROUND} stroke={color} strokeWidth={CIRCLE_MARKER_STROKE_WIDTH}/>
        </marker>
      );
    }
    if (kind === FlowchartMarkerKind.Cross) {
        return (
        <marker id={id} markerWidth={MARKER_SIZE} markerHeight={MARKER_SIZE} refX={CENTER_MARKER_REF} refY={CENTER_MARKER_REF} orient={orient} markerUnits={MARKER_UNITS_USER_SPACE}>
          <path d={CROSS_MARKER_PATH} stroke={color} strokeWidth={CROSS_MARKER_STROKE_WIDTH} strokeLinecap="round"/>
        </marker>
      );
    }
    return null;
}
